<div class="modal" id="modal-details" style="display: block;">
  <div class="modal-content">
    <span class="close" (click)="close()">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.0005 5L5.00049 19M5.00049 5L19.0005 19" stroke="#5C6465" stroke-width="1.5"
          stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </span>
      <div class="modal-content-view">
        <div>
          <h4>{{ role.title || role.name }}</h4>
          @if (role.title) {
            <div>
              <span>Code</span>
              <div class="badge">{{ role.name }}</div>
            </div>
          }
          <p class="text-gray">{{ role.description }}</p>
        </div>
        <div class="profil-aside">

          <!-- Statistiques -->
          <div class="profil-aside-item">
            <div class="flex align-center gap-8 text-gray">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7 17L7 13M12 17L12 7M17 17L17 11M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
                  stroke="#5C6465" stroke-width="1.5" stroke-linejoin="round" />
                </svg>
                <span>Statistiques</span>
              </div>
              <ul class="profil-aside-list">
                <li><span>Utilisateurs</span>
                <div class="text-blue">-</div>
              </li>
              <li><span>Groupes</span>
              <div class="text-blue">-</div>
            </li>
          </ul>
        </div>

        <!-- Propriétés -->
        <div class="profil-aside-item">
          <div class="flex align-center gap-8 text-gray">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2 18C2 16.4596 2 15.6893 2.34673 15.1235C2.54074 14.8069 2.80693 14.5407 3.12353 14.3467C3.68934 14 4.45956 14 6 14C7.54044 14 8.31066 14 8.87647 14.3467C9.19307 14.5407 9.45926 14.8069 9.65327 15.1235C10 15.6893 10 16.4596 10 18C10 19.5404 10 20.3107 9.65327 20.8765C9.45926 21.1931 9.19307 21.4593 8.87647 21.6533C8.31066 22 7.54044 22 6 22C4.45956 22 3.68934 22 3.12353 21.6533C2.80693 21.4593 2.54074 21.1931 2.34673 20.8765C2 20.3107 2 19.5404 2 18Z"
                stroke="#5C6465" stroke-width="1.5" />
                <path
                  d="M14 18C14 16.4596 14 15.6893 14.3467 15.1235C14.5407 14.8069 14.8069 14.5407 15.1235 14.3467C15.6893 14 16.4596 14 18 14C19.5404 14 20.3107 14 20.8765 14.3467C21.1931 14.5407 21.4593 14.8069 21.6533 15.1235C22 15.6893 22 16.4596 22 18C22 19.5404 22 20.3107 21.6533 20.8765C21.4593 21.1931 21.1931 21.4593 20.8765 21.6533C20.3107 22 19.5404 22 18 22C16.4596 22 15.6893 22 15.1235 21.6533C14.8069 21.4593 14.5407 21.1931 14.3467 20.8765C14 20.3107 14 19.5404 14 18Z"
                  stroke="#5C6465" stroke-width="1.5" />
                  <path
                    d="M2 6C2 4.45956 2 3.68934 2.34673 3.12353C2.54074 2.80693 2.80693 2.54074 3.12353 2.34673C3.68934 2 4.45956 2 6 2C7.54044 2 8.31066 2 8.87647 2.34673C9.19307 2.54074 9.45926 2.80693 9.65327 3.12353C10 3.68934 10 4.45956 10 6C10 7.54044 10 8.31066 9.65327 8.87647C9.45926 9.19307 9.19307 9.45926 8.87647 9.65327C8.31066 10 7.54044 10 6 10C4.45956 10 3.68934 10 3.12353 9.65327C2.80693 9.45926 2.54074 9.19307 2.34673 8.87647C2 8.31066 2 7.54044 2 6Z"
                    stroke="#5C6465" stroke-width="1.5" />
                    <path
                      d="M14 6C14 4.45956 14 3.68934 14.3467 3.12353C14.5407 2.80693 14.8069 2.54074 15.1235 2.34673C15.6893 2 16.4596 2 18 2C19.5404 2 20.3107 2 20.8765 2.34673C21.1931 2.54074 21.4593 2.80693 21.6533 3.12353C22 3.68934 22 4.45956 22 6C22 7.54044 22 8.31066 21.6533 8.87647C21.4593 9.19307 21.1931 9.45926 20.8765 9.65327C20.3107 10 19.5404 10 18 10C16.4596 10 15.6893 10 15.1235 9.65327C14.8069 9.45926 14.5407 9.19307 14.3467 8.87647C14 8.31066 14 7.54044 14 6Z"
                      stroke="#5C6465" stroke-width="1.5" />
                    </svg>
                    <span>Propriétés</span>
                  </div>
                  <ul class="profil-aside-list">
                    <li>
                      <span>Rôle composite</span>
                      <div class="badge">{{ role.composite ? 'Oui' : 'Non' }}</div>
                    </li>
                    <li>
                      <span>Rôle client</span>
                      <div class="badge">{{ role.clientRole ? 'Oui' : 'Non' }}</div>
                    </li>
                  </ul>
                </div>

                <!-- Boutons d'action -->
                <div class="two-buttons fix-bottom">
                  <button class="button flat-danger rounded" (click)="openDeleteDialog()">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5"
                        stroke="#EF4025" stroke-width="1.5" stroke-linecap="round" />
                        <path
                          d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5"
                          stroke="#EF4025" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                        <span>Supprimer</span>
                      </button>
                      <button class="button neutral rounded" (click)="editRole()">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M14.0737 3.88545C14.8189 3.07808 15.1915 2.6744 15.5874 2.43893C16.5427 1.87076 17.7191 1.85309 18.6904 2.39232C19.0929 2.6158 19.4769 3.00812 20.245 3.79276C21.0131 4.5774 21.3972 4.96972 21.6159 5.38093C22.1438 6.37312 22.1265 7.57479 21.5703 8.5507C21.3398 8.95516 20.9446 9.33578 20.1543 10.097L10.7506 19.1543C9.25288 20.5969 8.504 21.3182 7.56806 21.6837C6.63212 22.0493 5.6032 22.0224 3.54536 21.9686L3.26538 21.9613C2.63891 21.9449 2.32567 21.9367 2.14359 21.73C1.9615 21.5234 1.98636 21.2043 2.03608 20.5662L2.06308 20.2197C2.20301 18.4235 2.27297 17.5255 2.62371 16.7182C2.97444 15.9109 3.57944 15.2555 4.78943 13.9445L14.0737 3.88545Z"
                            stroke="#263435" stroke-width="1.5" stroke-linejoin="round" />
                            <path d="M13 4L20 11" stroke="#263435" stroke-width="1.5" stroke-linejoin="round" />
                            <path d="M14 22L22 22" stroke="#263435" stroke-width="1.5" stroke-linecap="round"
                              stroke-linejoin="round" />
                            </svg>
                            <span>Modifier</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>